const MAX_LENGTH_PASSWORD = 20;
const MAX_LENGTH_EMAIL = 256;
const MAX_LENGTH_TEXT = 256;

export { MAX_LENGTH_PASSWORD,MAX_LENGTH_EMAIL, MAX_LENGTH_TEXT };
